<template>
  <o-view>
    <o-nav-bar
      title="Mijn tickets"
      :has-back-button="true"
    />
  </o-view>
</template>

<script>
export default {
  name: 'Wallet'
}
</script>
